import { apiFetch, getToken } from "./api";

export function getDevices(token) {
  // Trailing slash matters: FastAPI's route is "/devices/" and a redirect
  // would escape the /api proxy and drop the Authorization header.
  return apiFetch("/devices/?active_only=true", {
    cache: "no-store",
    headers: { Authorization: `Bearer ${token || getToken()}` },
  });
}

export function getDevice(token, id) {
  return apiFetch(`/devices/${id}`, {
    cache: "no-store",
    headers: { Authorization: `Bearer ${token || getToken()}` },
  });
}

export function createDevice(payload) {
  return apiFetch("/devices/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function updateDevice(id, payload) {
  return apiFetch(`/devices/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function rotatePairingKey(id) {
  return apiFetch(`/devices/${id}/rotate-pairing-key`, { method: "POST" });
}

export function deleteDevice(id) {
  return apiFetch(`/devices/${id}`, { method: "DELETE" });
}

export function assignDevice(beid, userId) {
  return apiFetch(`/devices/${encodeURIComponent(beid)}/assignment`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_id: Number(userId) }),
  });
}

export function unassignDevice(beid, userId) {
  return apiFetch(`/devices/${encodeURIComponent(beid)}/assignment/${Number(userId)}`, { method: "DELETE" });
}
